import { Button, Spinner } from 'react-bootstrap';
import PlayIcon from '../../icons/play.icon';
import moment from "moment"
import useTakeControlAccessSession from '../../../hooks/take-control-access-session.hook';

const getStartEndDate = (historyItem) => (
  `${moment(historyItem?.StartDate).format("lll")} - ${moment(historyItem?.EndDate).format("lll")}`
);

const variantStyle1 = "style1";

const TemporarySupportAccess = ({ session, customerId, refreshTempAccessList, variant = variantStyle1 }) => {
  const { isLoading, takeControl } = useTakeControlAccessSession();

  const onTakeControl = () => {
    takeControl({
      customerId: customerId,
      accessSessionId: session?.objId
    }).then(() => {
      refreshTempAccessList();
    });
  }

  return (
    <div className={`bg-grey d-flex align-items-center justify-content-between temporary-support-access ${variant === variantStyle1 ? 'style1' : ''}`}>
      <div className="d-flex" style={{ gap: '8px' }}>
        {variant === variantStyle1 && (
          <div className='px-1'>
            <PlayIcon width="9px" height="12px" />
          </div>
        )}
        <div>
          <div style={{ lineHeight: '22px' }}>Temporary Support Access</div>
          <div>
            <span className="f-grey" style={{ lineHeight: '22px' }}>
              {getStartEndDate(session)}
            </span>{" "}
            &nbsp;
            <span className="f-green-2 ml-1" style={{ lineHeight: '22px' }}>Active</span>
          </div>
        </div>
      </div>
      <div className='btns-container'>
        {variant === variantStyle1 && (
          <Button className='details'>Details</Button>
        )}
        <Button 
          className="take-control" 
          onClick={onTakeControl}
          disabled={isLoading}
        >
          <div className="d-flex align-items-center">
            <img
              src="/images/msp/white-open-door.svg"
              alt=""
              className="mr-2"
            />
            {'Take Control'}
            {isLoading && (
              <Spinner
                animation="border"
                variant="light"
                size="sm"
                className="mx-2"
                style={{
                  width: "12px",
                  height: "12px",
                }}
              />
            )}
          </div>
        </Button>
      </div>
    </div>
  );
}

export default TemporarySupportAccess;
